import LayoutCreditCardPage from 'components/Content/ContentLayout/LayoutCreditCardPage/LayoutCreditCardPage';

export default LayoutCreditCardPage;
